// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LCZaN","col":"styles_col__B9kzV"};